import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * TalkingData 埋点
 * 现云客赞使用3套数据统计：自有大数据、友盟、TalkingData；正常使用的是大数据，TD刚接入但还不可用，
 * 需重新梳理需求，将TD利用起来长远角度考虑，只使用2套系统：
 */
/* eslint-disable */
import { isYkzMiniprogram, isYkzAlipayMiniprogram } from "@ykz/ykz-util/platform";
export function buryingPoint(event_id, event_label, additional_parameters, goods_id) {
  var promoterIdentity = -1;
  var userInfo = JSON.parse(localStorage.getItem("globalUserLocationInfo")) || JSON.parse(sessionStorage.getItem("globalUserLocationInfo")) || {};
  var location = JSON.parse(localStorage.getItem("shopping_mall_city")) || {};
  var isMini = isYkzMiniprogram();
  var isAlipayMini = isYkzAlipayMiniprogram();
  if (window.promoterStatusData && window.promoterStatusData.type == "2") {
    promoterIdentity = "企业";
  }
  if (window.promoterStatusData && window.promoterStatusData.type == "1") {
    promoterIdentity = window.promoterStatusData.isExcellence ? "优秀" : "普通";
  }
  var kv = _objectSpread({
    is_promoter: window.promoterStatusData && window.promoterStatusData.isPopularizer ? 1 : 0 || "",
    // open_id: window.openId || '',
    // promoter_id:  window.promoterStatusData.promoterId || -1,
    home_page_city: location.cityName || "",
    home_page_location: location.districtName || "",
    GPS_province: userInfo.province || "",
    GPS_city: userInfo.city || "",
    GPS_location: userInfo.district || "",
    platfrom: isMini ? "wxMini" : isAlipayMini ? "alipayMini" : "h5",
    promoter_level: window.promoterStatusData && window.promoterStatusData.memberLevel || -1,
    promoter_identity: promoterIdentity
  }, additional_parameters);
  if (typeof TDAPP != "undefined") {
    TDAPP.onEvent(event_id, "", kv);
  }
}